import { create } from "zustand";
import useUserStore from "@/store/userStore";

type ViewModeType = "admin" | "user" | "unapproved";

interface ViewModeState {
  viewMode: ViewModeType;
  setViewMode: (mode: ViewModeType) => void;
  resetViewMode: () => void;
}

export const useViewModeStore = create<ViewModeState>((set) => ({
  viewMode: "admin",
  setViewMode: (mode) => set({ viewMode: mode }),
  resetViewMode: () => set({ viewMode: "admin" }),
}));

const hasPermission = (permissions: string | undefined, perm: string) =>
  (permissions || "").split(",").map(s => s.trim()).includes(perm);

const useViewMode = () => {
  const { roleId, userStateCode, permissions } = useUserStore();
  const { viewMode } = useViewModeStore();

  const isViewAsUser = viewMode === "user";
  const isViewAsUnapproved = viewMode === "unapproved";

  const effectiveRoleId = viewMode !== "admin" ? "USER" : roleId;
  const effectiveStateCode = isViewAsUnapproved ? "00" : userStateCode;
  const isAdmin = effectiveRoleId === "ADMIN" || effectiveRoleId === "MINISTRY";
  const isRealAdmin = roleId === "ADMIN" || roleId === "MINISTRY";
  const hasAnyPermission = hasPermission(permissions, "parking");
  const canAccessAdmin = isAdmin || hasAnyPermission;

  return { effectiveRoleId, effectiveStateCode, isAdmin, isRealAdmin, isViewAsUser, isViewAsUnapproved, viewMode, canAccessAdmin };
};

export default useViewMode;
